/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreHome = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.109 7.534L9.271 2.463c-.709-.599-1.724-.63-2.545.044L.468 7.52a.501.501 0 0 0 .625.782l1.412-1.133v7.262c0 .265.215.48.48.48h2.877a.48.48 0 0 0 .48-.48v-3.837H9.22v3.837c0 .265.214.48.479.48h2.878a.48.48 0 0 0 .48-.48V7.072l1.396 1.216a.5.5 0 0 0 .656-.754z"
    />
  </svg>
);

IconCoreHome.displayName = 'IconCoreHome';

IconCoreHome.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreHome);
IconCoreHome.displayName = 'IconCoreHome';
